import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import StatsItem from './StatsItem';

const styles = (theme: Theme) => createStyles({
  statsContainer: {
    maxWidth: 1440,
    backgroundColor: '#033349',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    textTransform: 'uppercase'
  }
});

interface StatsItemProps {
  count?: number;
  text: string;
}

interface StatsContainerProps {
  items: StatsItemProps[];
}

const StatsContainer: React.SFC<WithStyles & StatsContainerProps> = ({
  classes,
  items
}) => {
  return (
    <Grid item container className={classes.statsContainer} alignItems="flex-start">
      {items.map((item, index) => (
        <StatsItem key={`stats_item_${index}`} count={item.count} text={item.text} />
      ))}
    </Grid>
  );
}

export default withStyles(styles)(StatsContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/StatsContainer.tsx